module.exports = __webpack_public_path__ + "static/media/logo_animalcrossing_en.60d732ad.png";